import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import TableView from './TableView';
import GalleryView from './GalleryView';
import PWDModal from './PWDModal';
import './BoardList.scss';

const BoardList = ({ type, title, onDetail, onWrite }) => {
  const [data, setData] = useState([]);
  const [pwdOpen, setPwdOpen] = useState(false);
  const [pwdLoading, setPwdLoading] = useState(false);
  const [pwdError, setPwdError] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);

  const isRequestBoard = useMemo(() => type === 'sample' || type === 'quote', [type]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (type === 'notice') {
          const res = await axios.get(`/api/user/boards?board_type=notice`);
          const total = res.data.length; // 전체 데이터 개수

          const mappedNotice = res.data.map((item, index) => ({
            ...item,
            // [수정] DB ID 대신 글 순서대로 번호 부여 (전체 개수 - 인덱스)
            displayNo: total - index,
            isNotice: item.is_pinned === 1,
            writer: '관리자',
            date: new Date(item.created_at).toISOString().split('T')[0],
            hasFile: !!item.file_url,
            hit: item.view_count || 0,
          }));
          setData(mappedNotice);
          return;
        }

        if (isRequestBoard) {
          const res = await axios.get(`/api/user/requests?type=${type}`);
          const total = res.data.length; // 전체 데이터 개수

          const mappedRequests = res.data.map((item, index) => ({
            ...item,
            // [수정] DB ID 대신 글 순서대로 번호 부여 (전체 개수 - 인덱스)
            displayNo: total - index,
            writer: item.author_name
              ? item.author_name.length > 1
                ? `${item.author_name[0]}*${item.author_name.slice(2)}`
                : item.author_name
              : '작성자',
            date: new Date(item.created_at).toISOString().split('T')[0],
            isPrivate: Number(item.is_private) === 1,
          }));
          setData(mappedRequests);
          return;
        }

        setData([]);
      } catch (err) {
        console.error('데이터 연동 실패:', err);
        setData([]);
      }
    };

    fetchData();
  }, [type, isRequestBoard]);

  const handleRowClick = async (item) => {
    if (type === 'notice') {
      // item.id는 실제 DB 값이므로 상세 페이지 이동 시 그대로 사용됩니다.
      onDetail(item);
      return;
    }

    if (Number(item.is_private) === 1 || item.isPrivate) {
      setSelectedItem(item);
      setPwdError('');
      setPwdOpen(true);
      return;
    }

    onDetail(item);
  };

  const handleVerifyPassword = async (password) => {
    if (!selectedItem) return;

    try {
      setPwdLoading(true);
      setPwdError('');

      const res = await axios.post('/api/user/requests/verify', {
        id: selectedItem.id, // 실제 DB ID 사용
        password,
      });

      if (res.data?.success) {
        setPwdOpen(false);
        setSelectedItem(null);
        onDetail(res.data.data);
      } else {
        setPwdError('비밀번호가 일치하지 않습니다.');
      }
    } catch (err) {
      setPwdError(err?.response?.data?.message || '비밀번호 확인에 실패했습니다.');
    } finally {
      setPwdLoading(false);
    }
  };

  return (
    <div className="board-list-wrap">
      {type !== 'notice' && (
        <div className="board-action">
          <button className="btn-write" onClick={onWrite}>
            {type === 'quote' ? '견적 문의하기' : '샘플 신청하기'}
          </button>
        </div>
      )}
      <div className="board-main-content">
        {type === 'gallery' ? (
          <GalleryView data={data} onDetail={handleRowClick} />
        ) : (
          <TableView data={data} type={type} onDetail={handleRowClick} />
        )}
      </div>

      <PWDModal
        open={pwdOpen}
        title={selectedItem?.title}
        loading={pwdLoading}
        error={pwdError}
        onClose={() => {
          setPwdOpen(false);
          setSelectedItem(null);
          setPwdError('');
        }}
        onConfirm={handleVerifyPassword}
      />
    </div>
  );
};

export default BoardList;
